<template>
    <Breadcrumbs main="Ui Kits" title="Tag & Pills" />
    <div class="container-fluid">
        <div class="row">
            <badgesContextual />
            <pillsContextual />
            <numberBadge />
            <pillsTags />
            <tagsIcons />
            <roundedPills />
            <tagsSection />
        </div>
    </div>
</template>
<script lang="ts" setup>
import { ref, defineAsyncComponent } from 'vue'
const badgesContextual = defineAsyncComponent(() => import("@/components/theme/uikits/tag&pills/badgesContextual.vue"))
const pillsContextual = defineAsyncComponent(() => import("@/components/theme/uikits/tag&pills/pillsContextual.vue"))
const numberBadge = defineAsyncComponent(() => import("@/components/theme/uikits/tag&pills/numberBadge.vue"))
const pillsTags = defineAsyncComponent(() => import("@/components/theme/uikits/tag&pills/pillsTags.vue"))
const tagsIcons = defineAsyncComponent(() => import("@/components/theme/uikits/tag&pills/tagsIcons.vue"))
const roundedPills = defineAsyncComponent(() => import("@/components/theme/uikits/tag&pills/roundedPills.vue"))
const tagsSection = defineAsyncComponent(() => import("@/components/theme/uikits/tag&pills/tagsSection.vue"))
</script>